<div class="analytics-widget-container">
  <mat-card class="analytics-widget">
    <mat-card-content>
      <mat-card-title>
        <mat-icon>supervisor_account</mat-icon>User Interaction Analytics
      </mat-card-title>

      <!-- Loading State -->
      @if (isLoading) {
        <div class="loading-state">
          <mat-progress-spinner
            diameter="50"
            mode="indeterminate"
          ></mat-progress-spinner>
          <span>Loading analytics data...</span>
        </div>
      }

      <!-- Default Analytics Data (Last Day & Last Week) -->
      @if (!isLoading && data && isDefaultAnalytics()) {
        <div class="analytics-content">
          <mat-tab-group>
            <!-- Last Day Tab -->
            <mat-tab label="Last Day">
              <div class="metrics-grid">
                <div class="metric-card total-interactions-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">forum</mat-icon>
                    <span class="metric-title">Total Interactions*</span>
                  </div>
                  <div class="metric-value">
                    {{
                      formatNumber(getDefaultData().lastDay.totalInteractions)
                    }}
                  </div>
                  <div class="metric-subtitle">
                    {{
                      formatDateRange(
                        getDefaultData().lastDay.dateRange.startDate,
                        getDefaultData().lastDay.dateRange.endDate
                      )
                    }}
                  </div>
                  <div class="metric-subtitle">
                    *Text + Voice to Voice Conversations
                  </div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">chat</mat-icon>
                    <span class="metric-title">Total Text Interactions</span>
                  </div>
                  <div class="metric-value">
                    {{
                      formatNumber(
                        getDefaultData().lastDay.textBasedInteractions
                      )
                    }}
                    <span class="metric-subtitle">
                      ({{
                        formatNumber(
                          getTextPercentage(getDefaultData().lastDay)
                        )
                      }}%)
                    </span>
                  </div>
                  <div class="metric-subtitle">
                    {{
                      formatDateRange(
                        getDefaultData().lastDay.dateRange.startDate,
                        getDefaultData().lastDay.dateRange.endDate
                      )
                    }}
                  </div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">chat</mat-icon>
                    <span class="metric-title"
                      >Total Voice to Voice Interactions</span
                    >
                  </div>
                  <div class="metric-value">
                    {{
                      formatNumber(
                        getDefaultData().lastDay.voiceToVoiceInteractions
                      )
                    }}
                    <span class="metric-subtitle">
                      ({{
                        formatNumber(
                          getVoicePercentage(getDefaultData().lastDay)
                        )
                      }}%)
                    </span>
                  </div>
                  <div class="metric-subtitle">
                    {{
                      formatDateRange(
                        getDefaultData().lastDay.dateRange.startDate,
                        getDefaultData().lastDay.dateRange.endDate
                      )
                    }}
                  </div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">people</mat-icon>
                    <span class="metric-title">Unique Users (text-only)</span>
                  </div>
                  <div class="metric-value">
                    {{ formatNumber(getDefaultData().lastDay.uniqueUsers) }}
                  </div>
                  <div class="metric-subtitle">Active users</div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">trending_up</mat-icon>
                    <span class="metric-title"
                      >Avg Interactions/User (text-only)</span
                    >
                  </div>
                  <div class="metric-value">
                    {{
                      formatAverage(
                        getDefaultData().lastDay.averageInteractionsPerUser
                      )
                    }}
                  </div>
                  <div class="metric-subtitle">Per user average</div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">camera_enhanced</mat-icon>
                    <span class="metric-title"
                      >Image attachment (text-only)
                    </span>
                  </div>
                  <div class="metric-grid">
                    <div class="title-and-value">
                      <div class="metric-title">Images uploaded</div>
                      <div class="metric-value">
                        {{
                          formatNumber(
                            getDefaultData().lastDay.imageInteractions
                          )
                        }}
                      </div>
                    </div>
                    <div class="title-and-value">
                      <div class="metric-title">Image interaction Rate*</div>
                      <div class="metric-value">
                        {{
                          formatNumber(
                            getDefaultData().lastDay.imageInteractionsRate,
                            true
                          )
                        }}
                      </div>
                      <div class="metric-subtitle">
                        * % of text-based conversations where an image was
                        attached
                      </div>
                    </div>
                  </div>
                  @if (!isCustomAnalytics()) {
                    <div class="see-image-convos">
                      <button
                        mat-raised-button
                        color="primary"
                        type="submit"
                        (click)="fetchImageData.emit('lastDay')"
                      >
                        <mat-icon>image_search</mat-icon>
                        <p>See image conversations (last day)</p>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </mat-tab>
            <!-- Last Week Tab -->
            <mat-tab label="Last Week">
              <div class="metrics-grid">
                <div class="metric-card total-interactions-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">forum</mat-icon>
                    <span class="metric-title">Total Interactions*</span>
                  </div>
                  <div class="metric-value">
                    {{
                      formatNumber(getDefaultData().lastWeek.totalInteractions)
                    }}
                  </div>
                  <div class="metric-subtitle">
                    *Text + Voice to Voice Conversations
                  </div>
                  <div class="metric-subtitle">
                    {{
                      formatDateRange(
                        getDefaultData().lastWeek.dateRange.startDate,
                        getDefaultData().lastWeek.dateRange.endDate
                      )
                    }}
                  </div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">chat</mat-icon>
                    <span class="metric-title">Total Text Interactions</span>
                  </div>
                  <div class="metric-value">
                    {{
                      formatNumber(
                        getDefaultData().lastWeek.textBasedInteractions
                      )
                    }}
                    <span class="metric-subtitle">
                      ({{
                        formatNumber(
                          getTextPercentage(getDefaultData().lastWeek)
                        )
                      }}%)
                    </span>
                  </div>
                  <div class="metric-subtitle">
                    {{
                      formatDateRange(
                        getDefaultData().lastWeek.dateRange.startDate,
                        getDefaultData().lastWeek.dateRange.endDate
                      )
                    }}
                  </div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">chat</mat-icon>
                    <span class="metric-title"
                      >Total Voice to Voice Interactions</span
                    >
                  </div>
                  <div class="metric-value">
                    {{
                      formatNumber(
                        getDefaultData().lastWeek.voiceToVoiceInteractions
                      )
                    }}
                    <span class="metric-subtitle">
                      ({{
                        formatNumber(
                          getVoicePercentage(getDefaultData().lastWeek)
                        )
                      }}%)
                    </span>
                  </div>
                  <div class="metric-subtitle">
                    {{
                      formatDateRange(
                        getDefaultData().lastWeek.dateRange.startDate,
                        getDefaultData().lastWeek.dateRange.endDate
                      )
                    }}
                  </div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">people</mat-icon>
                    <span class="metric-title">Unique Users (text-only)</span>
                  </div>
                  <div class="metric-value">
                    {{ formatNumber(getDefaultData().lastWeek.uniqueUsers) }}
                  </div>
                  <div class="metric-subtitle">Active users</div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">trending_up</mat-icon>
                    <span class="metric-title"
                      >Avg Interactions/User (text-only)</span
                    >
                  </div>
                  <div class="metric-value">
                    {{
                      formatAverage(
                        getDefaultData().lastWeek.averageInteractionsPerUser
                      )
                    }}
                  </div>
                  <div class="metric-subtitle">Per user average</div>
                </div>
                <div class="metric-card">
                  <div class="metric-header">
                    <mat-icon class="metric-icon">camera_enhanced</mat-icon>
                    <span class="metric-title"
                      >Image attachment (text-only)
                    </span>
                  </div>
                  <div class="metric-grid">
                    <div class="title-and-value">
                      <div class="metric-title">Images uploaded</div>
                      <div class="metric-value">
                        {{
                          formatNumber(
                            getDefaultData().lastWeek.imageInteractions
                          )
                        }}
                      </div>
                    </div>
                    <div class="title-and-value">
                      <div class="metric-title">Image interaction Rate*</div>
                      <div class="metric-value">
                        {{
                          formatNumber(
                            getDefaultData().lastWeek.imageInteractionsRate,
                            true
                          )
                        }}
                      </div>
                      <div class="metric-subtitle">
                        * % of text-based conversations where an image was
                        attached
                      </div>
                    </div>
                  </div>
                  @if (!isCustomAnalytics()) {
                    <div class="see-image-convos">
                      <button
                        mat-raised-button
                        color="primary"
                        type="submit"
                        (click)="fetchImageData.emit('lastWeek')"
                      >
                        <mat-icon>image_search</mat-icon>
                        <p>See image conversations (last week)</p>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      }

      <!-- Custom Date Range Analytics Data -->
      @if (!isLoading && data && isCustomAnalytics()) {
        <div class="analytics-content">
          <div class="custom-date-analytics">
            <h3 class="date-range-title">
              {{
                formatDateRange(
                  getCustomData().dateRange.startDate,
                  getCustomData().dateRange.endDate
                )
              }}
            </h3>
            <div class="metrics-grid">
              <div class="metric-card total-interactions-card">
                <div class="metric-header">
                  <mat-icon class="metric-icon">forum</mat-icon>
                  <span class="metric-title">Total Interactions*</span>
                </div>
                <div class="metric-value">
                  {{ formatNumber(getCustomData().totalInteractions) }}
                </div>
                <div class="metric-subtitle">
                  *Text + Voice to Voice Conversations
                </div>
                <div class="metric-subtitle">
                  {{
                    formatDateRange(
                      getCustomData().dateRange.startDate,
                      getCustomData().dateRange.endDate
                    )
                  }}
                </div>
              </div>
              <div class="metric-card">
                <div class="metric-header">
                  <mat-icon class="metric-icon">chat</mat-icon>
                  <span class="metric-title">Total Text Interactions</span>
                </div>
                <div class="metric-value">
                  {{ formatNumber(getCustomData().textBasedInteractions) }}
                  <span class="metric-subtitle">
                    ({{ formatNumber(getTextPercentage(getCustomData())) }}%)
                  </span>
                </div>
                <div class="metric-subtitle">Total text conversations</div>
              </div>
              <div class="metric-card">
                <div class="metric-header">
                  <mat-icon class="metric-icon">chat</mat-icon>
                  <span class="metric-title"
                    >Total Voice to Voice Interactions</span
                  >
                </div>
                <div class="metric-value">
                  {{ formatNumber(getCustomData().voiceToVoiceInteractions) }}
                  <span class="metric-subtitle">
                    ({{ formatNumber(getVoicePercentage(getCustomData())) }}%)
                  </span>
                </div>
                <div class="metric-subtitle">Total voice conversations</div>
              </div>
              <div class="metric-card">
                <div class="metric-header">
                  <mat-icon class="metric-icon">people</mat-icon>
                  <span class="metric-title">Unique Users (text-only)</span>
                </div>
                <div class="metric-value">
                  {{ formatNumber(getCustomData().uniqueUsers) }}
                </div>
                <div class="metric-subtitle">Active users</div>
              </div>
              <div class="metric-card">
                <div class="metric-header">
                  <mat-icon class="metric-icon">trending_up</mat-icon>
                  <span class="metric-title"
                    >Avg Interactions/User (text-only)</span
                  >
                </div>
                <div class="metric-value">
                  {{
                    formatAverage(getCustomData().averageInteractionsPerUser)
                  }}
                </div>
                <div class="metric-subtitle">Per user average</div>
              </div>
              <div class="metric-card">
                <div class="metric-header">
                  <mat-icon class="metric-icon">camera_enhanced</mat-icon>
                  <span class="metric-title"
                    >Image attachment (text-only)
                  </span>
                </div>
                <div class="metric-grid">
                  <div class="title-and-value">
                    <div class="metric-title">Images uploaded</div>
                    <div class="metric-value">
                      {{ formatNumber(getCustomData().imageInteractions) }}
                    </div>
                  </div>
                  <div class="title-and-value">
                    <div class="metric-title">Image interaction Rate*</div>
                    <div class="metric-value">
                      {{
                        formatNumber(
                          getCustomData().imageInteractionsRate,
                          true
                        )
                      }}
                    </div>
                    <div class="metric-subtitle">
                      * % of text-based conversations where an image was
                      attached
                    </div>
                  </div>
                </div>
                @if (getCustomData().imageInteractions > 0) {
                  <div class="see-image-convos">
                    <button
                      mat-raised-button
                      color="primary"
                      type="submit"
                      (click)="fetchImageData.emit('custom')"
                    >
                      <mat-icon>image_search</mat-icon>
                      <p>See image conversations</p>
                    </button>
                  </div>
                }
              </div>
            </div>
            <!-- Product Type Breakdown -->
            @if (getProductTypeEntries().length > 0) {
              <div class="product-breakdown">
                <h4 class="breakdown-title">
                  <mat-icon>pie_chart</mat-icon>
                  Product Type Breakdown (text interactions only)
                </h4>
                <div class="breakdown-grid">
                  @for (item of getProductTypeEntries(); track item.type) {
                    <div class="breakdown-item">
                      <div class="breakdown-header">
                        <span class="product-type">{{ item.type }}</span>
                        <span class="percentage"
                          >{{ item.percentage.toFixed(1) }}%</span
                        >
                      </div>
                      <div class="breakdown-count">
                        {{ formatNumber(item.count) }} interactions
                      </div>
                      <div class="breakdown-bar">
                        <div
                          class="breakdown-fill"
                          [style.width.%]="item.percentage"
                        ></div>
                      </div>

                      <div class="image-product-breakdown-count">
                        <mat-icon>camera_enhance</mat-icon>
                        {{ formatNumber(item.imageCount) }} images uploaded ({{
                          formatNumber(
                            (item.imageCount / item.count) * 100,
                            true
                          )
                        }})
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- No Data State -->
      @if (!isLoading && !data) {
        <div class="no-data">
          <mat-icon>analytics</mat-icon>
          <span>No analytics data available</span>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
